import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { ThreeDots } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { loginAdmin } from "../../services/authentification/AuthRequest";
import LOGO_MTN2 from "./../../assets/images/logo_momo.jpeg";

const Login = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [messageAlert, setMessageAlert] = useState("");

  const connexionAdmin = () => {
    setIsLoading(true);
    const data = {
      username: username,
      password: password,
    };

    try {
      loginAdmin(data)
        .then((res) => {
          setIsLoading(false);
          localStorage.setItem(
            "momo4scoohclient",
            res.data.accessToken
          );
          navigate("/entites");
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            setMessageAlert(err.response.data.donnee)
          } else {
            setMessageAlert('Une erreur s\'est produite, rééssayez!')
          }
          console.log("api error", err);
        });
    } catch (error) {
      setIsLoading(false);
      setMessageAlert('Quelque chose s\'est mal passé, rééssayer')
      console.log("catch error", error);
    }
  };

  useEffect(() => {
    function isEventExpired(currentDate, endDateInMilliseconds) {
      // Convert the milliseconds to a Date object
      const endDate = new Date(endDateInMilliseconds);

      // Compare the two dates
      if (currentDate > endDate) {
        // Event has expired
        return true;
      } else {
        // Event is still within time
        return false;
      }
    }

    if (localStorage.getItem("momo4scoohclient")) {
      const currentDate = new Date();
      const decodedToken = jwt_decode(localStorage.getItem("momo4scoohclient"));
      const expirationDate = new Date(decodedToken.exp * 1000);

      if (isEventExpired(currentDate, expirationDate)) {
        console.log("Login again");
      } else {
        console.log('already login')
        navigate("/entites");
      }
    }
  }, [])
  

  return (
    <div className="bg-[#f7f7f7] bg-img w-full h-screen flex flex-col items-center justify-center">
      <div>
        <div className="login-form bg-white/90 w-[450px] h-fit rounded-2xl shadow-2xl p-5">
          <div className="my-10">
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                disabled={isLoading}
                onChange={(e) => setUsername(e.target.value)}
                type="text"
                placeholder="schooloffice@gmail.com"
                className="input input-bordered w-full"
              />
            </div>
            <div className="form-control w-full mt-2">
              <label className="label">
                <span className="label-text">Mot de passe</span>
              </label>
              <input
                disabled={isLoading}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="******"
                className="input input-bordered w-full"
              />
            </div>
            <button
              disabled={isLoading}
              className="w-full h-11 rounded-lg mt-5 bg-momo-blue text-white font-medium flex items-center justify-center"
              onClick={connexionAdmin}
            >
              {!isLoading ? (
                <span>Se connecter</span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={isLoading}
                />
              )}
            </button>
            {messageAlert ? <div className="mt-5">
              <p className="text-red-500 text-center font-medium">{messageAlert}</p>
            </div> : null}
            <div className="flex justify-center mt-8">
              <Link to="/forget-password" className="underline">Mot de passe oublié ?</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
